import styled from 'styled-components';
import { colors } from '@karnott/colors';
import { StarIcon } from '@karnott/icons';
import { pixelSpacing } from '@karnott/theme';
import { formatArea } from '.';
import { UserUnitSystem } from '../constants';
import { UNDEFINED_CROP_ID } from '../constants/filtersConstants';
import { I18n } from '../i18n';
import { Crop } from '../slices/crops';

export const undefinedCropItem = {
  id: UNDEFINED_CROP_ID,
  label: I18n.t('Crop.undefined'),
};

export function buildCropLabel(crop: Crop, unit: UserUnitSystem) {
  let label = crop.name;
  label += crop.code ? ` (${crop.code}) ` : ' ';
  if (crop.parcel_count) {
    label += `(${crop.parcel_count} ${crop.parcel_count > 1 ? I18n.t('Filters.parcels') : I18n.t('Filters.parcel')}`;
    label += ' - ';
    label += `${formatArea(crop.parcel_area_sum, unit, true)})`;
  } else {
    label += `(0 ${I18n.t('Filters.parcel')})`;
  }
  return label;
}

export function getCropLabel(crop: Crop) {
  return crop
    ? crop.cluster_id
      ? crop.name === crop.base_crop
        ? crop.name
        : `${crop.name}${crop.base_crop ? ` (${crop.base_crop})` : ''}`
      : `[${crop.code}] ${crop.name}`
    : null;
}

const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${pixelSpacing('xSmall')};
`;

export function renderCropLabel(crop: Crop) {
  const label = getCropLabel(crop);
  return (
    <ListItem>
      <StarIcon size={16} color={crop.cluster_id ? colors('yellow', 400) : 'transparent'} fill />
      {label}
    </ListItem>
  );
}
